export default "__VITE_ASSET__DEMLT79M__"